"use client";

import { useCreateCurrentUserTermsOfServiceMutation } from "@yardzen/components-gql";
import { Checkbox } from "@yardzen/components/checkbox";
import { YardzenButton } from "@yardzen/components/yardzen-button";
import { useState } from "react";

interface AcceptTermsProps {
  userId: string;
  typeOfTos?: string;
  contractorId?: string;
}

export function AcceptTermsForm(props: AcceptTermsProps) {
  const [tosChecked, setTosChecked] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [
    createTermsOfService,
    { loading: updateSaving, error: mutationError },
  ] = useCreateCurrentUserTermsOfServiceMutation();

  const handleSubmission = async () => {
    setSubmitError(null);
    try {
      // Note: typeOfTos is supported by the GraphQL schema but the generated
      // TypeScript types are out of date. Using type assertion to bypass.
      const result = await createTermsOfService({
        variables: {
          input: {
            userId: props.userId,
            tosAgreed: tosChecked,
            dateOfAgree: new Date().toISOString(),
            ...(props.typeOfTos && { typeOfTos: props.typeOfTos }),
          } as any,
        },
      });
      if (result.errors) {
        setSubmitError("Failed to save terms acceptance. Please try again.");
        return;
      }
      // Force a full page reload to ensure the terms acceptance check re-runs
      // router.refresh() doesn't trigger Apollo queries to re-execute
      window.location.reload();
    } catch (error) {
      console.error("Error saving terms of service agreement", error);
      setSubmitError("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      <Checkbox
        id="terms-of-service-agreement"
        ariaLabel="terms-of-service-agreement"
        checked={tosChecked}
        onChange={(e) => setTosChecked(e.target.checked)}
        wrapperClassName="flex gap-2 items-start pt-4"
        labelClassName="text-typo-primary text-sm md:text-base"
        label="I agree to Yardzen's <a href='https://yardzen.com/terms-and-conditions' target='_blank' style='text-decoration: underline; color: rgb(29 78 216);'>Terms of Service</a> and <a href='https://yardzen.com/privacy-policy' target='_blank' style='text-decoration: underline; color: rgb(29 78 216);'>Privacy Policy</a>"
      ></Checkbox>
      {(submitError || mutationError) && (
        <p className="mt-2 text-sm text-red-600">
          {submitError || mutationError?.message}
        </p>
      )}
      <div className="flex flex-col items-center ">
        <YardzenButton
          disabled={!tosChecked}
          onClick={handleSubmission}
          loading={updateSaving}
          sx={{ marginTop: "2rem", width: "50%" }}
        >
          Continue
        </YardzenButton>
      </div>
    </div>
  );
}
